document.addEventListener('DOMContentLoaded',()=>{
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const open=document.querySelector('[data-menu-open]'),
        drawer=document.querySelector('[data-menu-drawer]'),
        close=document.querySelector('[data-menu-close]'),
        backdrop=document.querySelector('[data-drawer-backdrop]');
  const set=v=>{
    drawer?.classList.toggle('is-open',v);
    backdrop?.classList.toggle('is-open',v);
    document.body.style.overflow=v?'hidden':'';
  };
  open?.addEventListener('click',()=>set(true));
  close?.addEventListener('click',()=>set(false));
  backdrop?.addEventListener('click',()=>set(false));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')set(false)});

  document.querySelectorAll('[data-hero]').forEach(hero=>{
    const slides=[...hero.querySelectorAll('[data-slide]')],dots=[...hero.querySelectorAll('[data-dot]')];
    let i=0;
    const show=n=>{
      i=(n+slides.length)%slides.length;
      slides.forEach((s,x)=>{
        s.hidden=x!==i;
        s.classList.toggle('is-active',x===i);
      });
      dots.forEach((d,x)=>d.classList.toggle('is-active',x===i));
    };
    hero.querySelector('[data-prev]')?.addEventListener('click',()=>show(i-1));
    hero.querySelector('[data-next]')?.addEventListener('click',()=>show(i+1));
    dots.forEach((d,x)=>d.addEventListener('click',()=>show(x)));
    show(0);
  });

  if(!reduceMotion){
    const revealEls = document.querySelectorAll('.pp-section, .pp-values, .pp-footer, .pp-collection, .pp-product');
    revealEls.forEach(el=>el.classList.add('pp-reveal'));
    const revealObserver = new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },{threshold:.08,rootMargin:'0px 0px -36px'});
    revealEls.forEach(el=>revealObserver.observe(el));
  }

  if(finePointer && !reduceMotion){
    const cursor=document.createElement('div');
    cursor.className='pp-sun-cursor';
    cursor.setAttribute('aria-hidden','true');
    cursor.innerHTML=`<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M24 2v7M24 39v7M2 24h7M39 24h7M8.5 8.5l5 5M34.5 34.5l5 5M39.5 8.5l-5 5M13.5 34.5l-5 5"/></g><circle cx="24" cy="24" r="10.5" fill="currentColor"/><circle cx="20.5" cy="22" r="1.2" fill="#0D47A1"/><circle cx="27.5" cy="22" r="1.2" fill="#0D47A1"/><path d="M19.5 27c2.4 2.3 6.6 2.3 9 0" fill="none" stroke="#0D47A1" stroke-width="1.8" stroke-linecap="round"/></svg>`;
    document.body.appendChild(cursor);
    document.documentElement.classList.add('pp-custom-cursor');
    let x=-80,y=-80,tx=-80,ty=-80;
    const move=e=>{tx=e.clientX;ty=e.clientY;cursor.classList.add('is-on-screen')};
    document.addEventListener('mousemove',move,{passive:true});
    document.addEventListener('mouseleave',()=>cursor.classList.remove('is-on-screen'));
    const loop=()=>{
      x+=(tx-x)*.22; y+=(ty-y)*.22;
      cursor.style.transform=`translate3d(${x}px,${y}px,0) translate(-50%,-50%)`;
      requestAnimationFrame(loop);
    };
    loop();
    const interactive='a,button,input,select,summary,[role="button"]';
    document.addEventListener('mouseover',e=>{if(e.target.closest(interactive))cursor.classList.add('is-hovering')});
    document.addEventListener('mouseout',e=>{if(e.target.closest(interactive))cursor.classList.remove('is-hovering')});

    document.addEventListener('click',e=>{
      if(e.button!==0) return;
      const sparkle=document.createElement('span');
      sparkle.className='pp-click-sparkle';
      sparkle.textContent='✦';
      sparkle.style.left=`${e.clientX}px`;
      sparkle.style.top=`${e.clientY}px`;
      document.body.appendChild(sparkle);
      sparkle.addEventListener('animationend',()=>sparkle.remove(),{once:true});
    });
  }
});
